export default __webpack_public_path__ + "static/media/login_logo.88dc41c7.svg";